<template>
    <div class="container-fluid pl-0 pr-0">
        <div v-if="!showConfirm">
            <h2>Reset password</h2>
            <hr>
            <form>
                <div class="form-group">
                    <div class="row">
                        <label for="Email" class="col-2 d-flex align-self-center justify-content-end">
                            Email
                            <span class="required">*</span>
                        </label>
                        <div class="col-4">
                            <input for="Email" v-model="email" class="form-control validate-content validate-empty" />
                        </div>
                    </div>
                    <div class="row" v-if="v$.email.$error">
                        <div class="text-danger small col-4 offset-2" v-for="error of v$.email.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-6 d-flex justify-content-end">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="show-password" v-model="showpassword">
                                <label class="custom-control-label" for="show-password">Show Password</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label asp-for="Password" class="col-2 d-flex align-self-center justify-content-end">
                            Password
                            <span class="required">*</span>
                        </label>
                        <div class="col-4">
                            <input id="Password" v-model="password" v-bind:type="this.showpassword == true ? 'text' : 'password'" class="form-control validate-content validate-empty" />
                        </div>
                    </div>
                    <div id="password-validation-message" v-if="v$.password.$error">
                        <div class="row">
                            <div class="col-4 offset-2">
                                <h4 class="password-validation-heading small">Password must contain the following:</h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 offset-2">
                                <p id="password-validation-lowercase" class="password-validation password-validation-invalid small">A <b>lowercase</b> letter</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 offset-2">
                                <p id="password-validation-uppercase" class="password-validation password-validation-invalid small">A <b>capital (uppercase)</b> letter</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 offset-2">
                                <p id="password-validation-number" class="password-validation password-validation-invalid small">A <b>number</b></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4 offset-2">
                                <p id="password-validation-length" class="password-validation password-validation-invalid small">Minimum <b>6 characters</b></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label for="ConfirmPassword" class="col-2 d-flex align-self-center justify-content-end">
                            Confirm Password
                            <span class="required">*</span>
                        </label>
                        <div class="col-4">
                            <input id="ConfirmPassword" v-model="confirmpassword" v-bind:type="this.showpassword == true ? 'text' : 'password'" class="form-control validate-content validate-empty" />
                        </div>
                    </div>
                    <div class="row" v-if="v$.confirmpassword.$error">
                        <div class="text-danger small col-4 offset-2" v-for="error of v$.confirmpassword.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                    <div class="row" v-if="showFailure">
                        <div class="text-danger small col-4 offset-2">
                            Request Submission Failed
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <label class="col-2 control-label d-flex align-self-center justify-content-end font-weight-bold mb-0">Notice:</label>
                        <div class="col-10 d-flex align-self-center">
                            Please note that this will change your password for all Ultra Librarian websites and applications.
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <div class="row">
                        <div class="col-4 offset-2">
                            <input id="Submit" type="submit" class="btn btn-light" :disabled="v$.$invalid" value="Reset Password" @click.prevent="postForm" />
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div v-if="showConfirm">
            <h2>Your password has been reset</h2>
            <hr />
            <div class="d-flex flex-column">
                <a href @click.prevent="signIn">Click here to log in</a>
            </div>
        </div>
    </div>
</template>

<script>
    import accountApiClient from '@/services/apiServices/accountApiClient.js'
    import { mapActions, mapState } from 'vuex'
    import useVuelidate from '@vuelidate/core'
    import { required, email, minLength, sameAs } from '@vuelidate/validators'

    export default {
        name: 'ResetPassword',
        setup() {
            return { v$: useVuelidate() }
        },
        data() {
            return {
                email: "",
                password: "",
                confirmpassword: "",
                code: this.$route.query.code,
                showpassword: false,
                showConfirm: false,
                showFailure: false
            }
        },
        validations() {
            return {
                email: { required, email, $autoDirty: true },
                password: {
                    required, minLength: minLength(6),
                    containsUppercase: function (value) {
                        return /[A-Z]/.test(value)
                    },
                    containsLowercase: function (value) {
                        return /[a-z]/.test(value)
                    },
                    containsNumber: function (value) {
                        return /[0-9]/.test(value)
                    }, $autoDirty: true
                },
                confirmpassword: { required, sameAs: sameAs(this.password), $autoDirty: true },

            }
        },
        computed: {
            ...mapState({
                instance: state => state.instance,
            })
        },
        methods: {
            ...mapActions('oidcStore', [
                'authenticateOidc'
            ]),
            postForm: async function () {
                var confirmResult = await accountApiClient.ResetPassword(this.email, this.password, this.confirmPassword, this.code);
                if (confirmResult.status == 200 && confirmResult.data.success == true) {
                    this.showConfirm = true;
                    this.showFailure = false;
                } else { // bad response
                    this.showConfirm = false;
                    this.showFailure = true;
                }
            },
            signIn: function () {
                var configContent = JSON.parse(process.env.VUE_APP_OIDC_OPTIONS);
                var localOptions = {
                    extraQueryParams: {
                        "Base-Url": configContent.baseurl + this.$route.params.instance,
                        "App-Type": configContent.apptype,
                        "Custom-View": configContent.customView
                    }
                };
                this.authenticateOidc({ redirectPath: this.$route.query.returnUrl, options: localOptions });
            }
        }
    }
</script>

<style scoped>
</style>